import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { checkIsSuitableToClick, externalOnClickHandler } from "../../../Engine/ActionCreators/ExternalOnClickAction";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";
import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";

import { RadioGroup } from "./RadioGroup";

interface RadioGroupContainerProps extends FormActionHandlerExecutionInjectableProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
    disabled2?: EvaluableProp<boolean>;
    isReadOnly: boolean;
    callHelperOnChange?: FormActionHandler;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
}

const mapStateToProps = (state: FullFormState, ownProps: RadioGroupContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;
    const controlModel = viewModelSelect.controlModel(state, bindingPath);

    return {
        value: controlModel.value,
        disabled: controlModel.disabled || ownProps.processEvaluableProp(state, ownProps.disabled2),
        error: controlModel.error,
        // чиним проблему с побеждающим warning над error, анологично checkbox
        // это проблема react-ui, чинить пока не будут https://kontur.slack.com/archives/C013HTCE18Q/p1698216340082039
        warning: controlModel.error ? undefined : controlModel.warning,
        isReadOnly: state.settings.isReadOnly,
        isLink: checkIsSuitableToClick(state.settings, bindingPath),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: RadioGroupContainerProps) => {
    const { bindingPath } = ownProps;
    return {
        onChange: async (value: string) => {
            dispatch(setToModel(ownProps.bindingPath, "value", value));
            if (isNotNullOrUndefined(ownProps.callHelperOnChange)) {
                await ownProps.executeFormActionHandler(ownProps.callHelperOnChange);
            }
        },
        onClick: () => externalOnClickHandler(dispatch, bindingPath),
    };
};

export const RadioGroupContainer = withResolvePaths(
    withFormActionHandlerExecution(
        withViewModelSelect(
            withEvaluators(
                connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(
                    withFocusManagement(
                        withExternalMountingEventReporting(
                            withTestPageObjectRegistration(withControlDebugInfo(RadioGroup))
                        )
                    )
                )
            )
        )
    )
);
